import {
  Box,
  IconButton,
  ListItemIcon,
  ListItemText,
  Stack,
  TextField,
  styled
} from "@mui/material";

export const ItemIconPasswordCheck = styled(ListItemIcon)(() => ({
  minWidth: "20px",
  "& svg": {
    width: "14px",
    height: "14px",
  },
}));

export const ItemTextPasswordCheck = styled(ListItemText)(() => ({
  lineHeight: "1",
  margin: "0",
  "& span": {
    fontSize: "small",
  },
}));

export const BackgroundContainer = styled(Box)(() => ({
  backgroundImage: "url('/background.png')",
  backgroundSize: "cover",
  backgroundPosition: "center",
  height: "100vh",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
}));

export const AuthBox = styled(Box)(() => ({
  position: "relative",
  backgroundColor: "rgba(255, 255, 255, 0.8)",
  borderRadius: "5px",
  boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.2)",
  padding: "3rem",
  width: "45%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  maxHeight: "55vh",
  overflowY: "auto",
  margin: "0 auto",
  scrollbarGutter: "stable"
})) as typeof Box;

export const LeftContent = styled(Box)(() => ({
  width: "65%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  paddingRight: "2rem",
}));

export const RightContent = styled(Box)(() => ({
  width: "35%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  maxHeight: "100%",
  overflow: "hidden",
  img: {
    maxHeight: "100%",
    height: "auto",
  },
}));

export const StyledTextField = styled(TextField)(() => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "6px",
  },
})) as typeof TextField;

export const FooterContainer = styled("footer")(({ theme }) => ({
  position: "fixed",
  bottom: 0,
  left: 0,
  width: "100%",
  borderTop: `1px solid ${theme.palette.primary.main}`,
  backgroundColor: theme.palette.textMain.main,
  color: theme.palette.textMain.secondary,
  padding: "0.5rem 1rem",
  fontSize: "0.75rem",
}));

export const FooterContent = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  flexWrap: "wrap",
  gap: "0.5rem",
  alignItems: "center",
  maxWidth: "80%",
  margin: "0 auto",
  "& a": {
    color: theme.palette.textMain.secondary,
    textDecoration: "none",
  },
  "& span.separator": {
    margin: "0 0.5rem",
  },
}));

export const StepStack = styled(Stack)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const LoginLinkStack = styled(Stack)(({ theme }) => ({
  zIndex: 2,
  alignItems: "center",
  gap: theme.spacing(1),
}));

export const FlexRowBox = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  gap: 16,
}));

export const RoundIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.action.hover,
  color: theme.palette.primary.main,
  borderRadius: "50%",
  padding: theme.spacing(1),
  "&:hover": {
    backgroundColor: theme.palette.action.selected,
  },
}));

export const FixedHeightTextBox = styled(Box)(() => ({
  minHeight: "3em",
  display: "flex",
  alignItems: "center",
}));

export const LoginRow = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "1rem",
}));